import { z } from 'zod'
import { LoginManagerAccountType } from '@/enums/login-manager-account-type'
import { useStorage } from '~library/composables'
import { Identity, LocalStorage } from '~library/enums'

const rememberLoginInfoSchema = z.object({
  /** 身分別 */
  identity: z.nativeEnum(Identity),
  /** 經理人帳號類型 */
  managerAccountType: z.nativeEnum(LoginManagerAccountType),
  /** 帳號 */
  account: z.string()
})

export type RememberLoginInfo = z.infer<typeof rememberLoginInfoSchema>

/** 管理「記住登入資訊」的 localStorage 存取 */
export function useRememberLoginInfo() {
  const { getStorageData, setStorageData, removeStorageData } = useStorage()

  /** 儲存或移除記住的登入資訊 */
  const saveIsRememberLoginInfo = (data: RememberLoginInfo | null) => {
    if (data) {
      setStorageData(LocalStorage.IS_REMEMBER_LOGIN_INFO, data)
    } else {
      removeStorageData(LocalStorage.IS_REMEMBER_LOGIN_INFO)
    }
  }

  /** 取得記住的登入資訊 */
  const getIsRememberLoginInfo = (): RememberLoginInfo | null => {
    return (
      getStorageData({
        key: LocalStorage.IS_REMEMBER_LOGIN_INFO,
        zodSchema: rememberLoginInfoSchema
      }) ?? null
    )
  }

  return {
    /** 儲存或移除記住的登入資訊 */
    saveIsRememberLoginInfo,
    /** 取得記住的登入資訊 */
    getIsRememberLoginInfo
  }
}
